import { render, staticRenderFns } from "./PayPalCasesModule.vue?vue&type=template&id=53dbfa7c&scoped=true"
import script from "./PayPalCasesModule.vue?vue&type=script&lang=js"
export * from "./PayPalCasesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dbfa7c",
  null
  
)

export default component.exports